/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DepartmentEventMetricsTrackingList = {
    properties: {
        department: {
    type: 'Department',
    isRequired: true,
},
        eventMetrics: {
    type: 'array',
    contains: {
        type: 'EventMetric',
    },
    isRequired: true,
},
    },
};